import { DAppService, NotificationService, ProjectService } from '../domain'
import {
	ForAttestation,
	ForEventsMessaging,
	ForManagingAccount,
	ForManagingDApps,
	ForManagingEntitlements,
	ForManagingProjects,
	ForManagingTeamMembers,
	ForManagingTeams,
	ForOnboardingUser
} from '../ports'

export class Application {
	private readonly _forAttestation: ForAttestation
	private readonly _forEventsMessaging: ForEventsMessaging
	private readonly _forManagingAccount: ForManagingAccount
	private readonly _forManagingDApps: ForManagingDApps
	private readonly _forManagingEntitlements: ForManagingEntitlements
	private readonly _forManagingProjects: ForManagingProjects
	private readonly _forManagingTeamMembers: ForManagingTeamMembers
	private readonly _forOnboardingUser: ForOnboardingUser
	private readonly _forManagingTeams: ForManagingTeams

	constructor(arg: {
		forManagingAccount: ForManagingAccount
		forManagingDApps: ForManagingDApps
		forManagingEntitlements: ForManagingEntitlements
		forManagingProjects: ForManagingProjects
		forManagingTeamMembers: ForManagingTeamMembers
		forOnboardingUser: ForOnboardingUser
		forEventsMessaging: ForEventsMessaging
		forAttestation: ForAttestation
		forManagingTeams: ForManagingTeams
	}) {
		this._forManagingAccount = arg.forManagingAccount
		this._forManagingDApps = arg.forManagingDApps
		this._forManagingEntitlements = arg.forManagingEntitlements
		this._forManagingProjects = arg.forManagingProjects
		this._forOnboardingUser = arg.forOnboardingUser
		this._forEventsMessaging = arg.forEventsMessaging
		this._forAttestation = arg.forAttestation
		this._forManagingTeams = arg.forManagingTeams
		this._forManagingTeamMembers = arg.forManagingTeamMembers
	}

	forEventsMessaging() {
		return new NotificationService(this._forEventsMessaging)
	}

	forManagingProjects() {
		return new ProjectService(this._forManagingProjects)
	}

	forManagingDApps() {
		return new DAppService(this._forManagingDApps)
	}

	forManagingEntitlements() {
		return this._forManagingEntitlements
	}

	forManagingAccount() {
		return this._forManagingAccount
	}

	forOnboardingUser() {
		return this._forOnboardingUser
	}

	forAttestation(): ForAttestation {
		return this._forAttestation
	}

	forManagingTeams() {
		return this._forManagingTeams
	}

	forManagingTeamMembers() {
		return this._forManagingTeamMembers
	}
}
